import { useMemo } from 'react';
import useTargetEntityDomainsToType from '../hooks/useTargetEntityDomainsToType';

import { ENTITY_TYPE_RELATIONSHIP_SERVICE_METADATA } from '../consts';

export default (sourceEntityType, targetEntityTypes, relationships) => {
  const targetEntityDomainsToType = useTargetEntityDomainsToType(targetEntityTypes);
  return useMemo(() => {
    const isEntityOfType = (entity, entityType) =>
      entity.domain === ENTITY_TYPE_RELATIONSHIP_SERVICE_METADATA[entityType].domain &&
      entity.type === ENTITY_TYPE_RELATIONSHIP_SERVICE_METADATA[entityType].type;
    const isSourceEntity = entity => isEntityOfType(entity, sourceEntityType);
    const getTargetEntityType = entity =>
      targetEntityDomainsToType[entity.domain] &&
      targetEntityDomainsToType[entity.domain][entity.type];

    const result = [];
    relationships.forEach(relationship => {
      // We currently want to handle only 1 to 1 links.
      if (relationship.entities.length === 2) {
        relationship.entities.forEach(entity => {
          const entityType = getTargetEntityType(entity);
          if (entityType && !isSourceEntity(entity)) {
            result.push({
              entityId: entity.id,
              entityType,
              relationship
            });
          }
        });
      }
    });
    return result;
  }, [relationships, targetEntityDomainsToType, sourceEntityType]);
};
